//
//
//
//
//
//
//
//

export default {
    name: 'App',
    data() {
        return {
            type: null
        };
    },
    created() {
        this.type = this.$store.state.routerType;
    }
};
